import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withTheme } from 'styled-components';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
/**
 * @deprecated the ShimBackgroundType enum is deprecated. Please use one of the string values instead.
 */
export var ShimBackgroundType;
(function (ShimBackgroundType) {
    ShimBackgroundType["OPAQUE"] = "opaque";
    ShimBackgroundType["TRANSPARENT"] = "transparent";
})(ShimBackgroundType || (ShimBackgroundType = {}));
const animationClassName = 'animation';
const StyledShimLayer = styled.div.withConfig({ displayName: "StyledShimLayer", componentId: "sc-fcqlz9" }) `position:fixed;top:0;right:0;bottom:0;left:0;background-color:${({ theme, backgroundType }) => backgroundType === 'transparent'
    ? 'transparent'
    : theme.colors.overlay.default};opacity:1;transition:${({ theme }) => {
    const duration = theme.animation.duration.layer;
    const timingFunction = theme.animation.timingFunction.in;
    return `opacity ${duration} ${timingFunction}`;
}};&.${animationClassName}-exit{opacity:1;}&.${animationClassName}-enter,&.${animationClassName}-exit-active,&.${animationClassName}-exit-done{opacity:0;}&.${animationClassName}-enter-active{opacity:1;}`;
StyledShimLayer.displayName = 'StyledShimLayer';
export const InternalShimLayer = (props) => {
    const { backgroundType = 'opaque', in: visible, onExited } = props;
    const commonProps = getCommonProps(props);
    const handleClick = (event) => {
        const { onClick = () => undefined } = props;
        onClick(event);
    };
    const timeout = parseInt(props.theme.animation.duration.layer || '0', 10);
    return (React.createElement(CSSTransition, { classNames: animationClassName, onExited: onExited, in: visible, timeout: timeout },
        React.createElement(StyledShimLayer, Object.assign({ onClick: handleClick, backgroundType: backgroundType }, commonProps))));
};
export const ShimLayer = withTheme(InternalShimLayer);
